// frontend/src/pages/MapPopup.jsx
// 팝업 지도창 — 별도 브라우저 창에서 마커만 그리고, 클릭을 원본 창으로 되돌려보냅니다.
//   · 데이터는 스스로 안 부릅니다. 원본 창(App.js)이 BroadcastChannel('momo-map')로
//     보내주는 properties/center/highlightedId 를 받아 KakaoMap 에 그대로 넘깁니다.
//   · 마커를 클릭하면 estate_no 를 원본 창으로 보냅니다 → 원본이 selectEstate() 실행.
import React, { useEffect, useRef, useState } from "react";
import KakaoMap from "../components/KakaoMap";

const CH = "momo-map";
// 원본이 아직 안 보냈을 때도 지도가 뜨도록 기본 중심(관악구청 부근)
const DEFAULT_CENTER = { lat: 37.4784, lng: 126.9516, level: 5 };

export default function MapPopup() {
  const [properties, setProperties]       = useState([]);
  const [center, setCenter]               = useState(DEFAULT_CENTER);
  const [highlightedId, setHighlightedId] = useState(null);
  const chRef = useRef(null);

  useEffect(() => {
    let ch;
    try { ch = new BroadcastChannel(CH); } catch (e) { ch = null; }
    chRef.current = ch;
    if (!ch) return;

    ch.onmessage = (ev) => {
      const m = ev.data || {};
      if (m.type === "sync") {
        if (Array.isArray(m.properties)) setProperties(m.properties);
        if (m.center && m.center.lat && m.center.lng) setCenter(m.center);
        setHighlightedId(m.highlightedId ?? null);
      }
    };
    // 원본 창에 "준비됨 — 현재 마커 보내줘"
    try { ch.postMessage({ type: "ready" }); } catch (e) {}

    document.title = "모모부동산 · 팝업지도";
    return () => { try { ch.close(); } catch (e) {} };
  }, []);

  const handleMarkerClick = (id, p) => {
    // 그룹이면 대표 estate_no, 단건이면 id
    const estateNo = (p && p.type === "group" && Array.isArray(p.items) && p.items[0])
      ? p.items[0].estate_no
      : id;
    try { chRef.current?.postMessage({ type: "markerClick", estate_no: estateNo }); } catch (e) {}
  };

  return (
    <div style={{ position: "fixed", inset: 0, width: "100vw", height: "100vh" }}>
      <KakaoMap
        properties={properties}
        center={center}
        highlightedId={highlightedId}
        onMarkerClick={handleMarkerClick}
      />
    </div>
  );
}
